module.exports = __webpack_public_path__ + "img/_PWK2661_-PSedit_.54a3fff0.jpeg";